import * as format from 'date-fns/format';
import * as isValid from 'date-fns/is_valid';
import * as parse from 'date-fns/parse';
import * as differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
import * as subDays from 'date-fns/sub_days';
import * as addDays from 'date-fns/add_days';

export class DateUtil {
  static readonly MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

  static formatDate(date: any, formatStr = 'YYYY-MM-DD'): string {
    if (date !== null && isValid(new Date(date))) {
      return format(date, formatStr);
    } else {
      return '';
    }
  }

  static parseDate(date: string): Date {
    return parse(date);
  }

  static isValidDateString(date: string): boolean {
    return this.isValidDate(this.parseDate(date));
  }

  static isValidDate(date: Date): boolean {
    return date instanceof Date && !isNaN(date.valueOf());
  }

  static differenceInCalendarDays(end: Date, start: Date) {
    return differenceInCalendarDays(end, start);
  }

  static subtractDaysFromDate(date: string, amount: number) {
    return subDays(date, amount);
  }

  static addDaysToDate(date: string, amount: number) {
    return addDays(date, amount);
  }

  static getLocalDateFormat(date: string): String {
    if (date !== null && isValid(new Date(date))) {
      return this.parseDate(date).toLocaleDateString();
    } else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/date.util.ts